<template>
    <div>
        <!-- SECCIONES -->
        <vx-card v-if="isMounted && !failed">
            <div slot="no-body" class="tabs-container px-6 pt-6">
                <vs-table ref="table" search stripe :data="documentsList" noDataText="No hay datos disponibles">
                    <template slot="header">
                        <h4 class="mr-4">Lista de documentos.</h4>
                        <vs-button @click="reloadDocumentStatus()" size="small">Actualizar</vs-button>
                    </template>
                    <template slot="thead">
                        <vs-th v-for="(col, idx) in columns" v-bind:key="idx"
                            :sort-key="col.sortable ? col.key : null">{{ col.title }}</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr v-for="(tr, index) in data" :key="index">
                            <vs-td>
                                {{ tr.n }}
                            </vs-td>
                            <vs-td>
                                <vs-chip :color="tr.color">
                                    {{ tr.e }}
                                </vs-chip>
                            </vs-td>
                            <vs-td>
                                {{ tr.section_id }} - {{ tr.section_name }}
                            </vs-td>
                            <vs-td>
                                {{ tr.is_required == 1 ? 'Si' : 'No' }}
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </div>
        </vx-card>

        <load-error v-if="failed" />

    </div>
</template>
  
<script>
import inputHelper from '@components/mixins/inputHelper';
import dateHelper from '@components/mixins/dateHelper';
import formHelper from '@components/mixins/formHelper';
import docsHelper from '@components/mixins/docsHelper';
import FormField from '@components/forms/FormField.vue'
import SupplierCitiesControl from '@supplier/SupplierCitiesControl.vue'
import SupplierTestimoniesControl from '@supplier/SupplierTestimoniesControl.vue'
import PersonalProfileTinsControl from '@supplier/PersonalProfileTinsControl.vue'
import BusinessProfileTinsControl from '@supplier/BusinessProfileTinsControl.vue'
import AccreditationsControl from '@supplier/AccreditationsControl.vue'
import SupplierBankAccountsControl from '@supplier/SupplierBankAccountsControl.vue'
import SupplierIdentityVerification from '@supplier/SupplierIdentityVerification.vue';
import userIdentityHelper from "@/helpers/userIdentityHelper";
import ContractsPage from "@supplier/ContractsPage";
import { Validator } from 'vee-validate'
import SupplierBranchesControl from '@supplier/SupplierBranchesControl.vue';

const pfaeTabsDefs = [
    { slug: "general", title: "Datos generales", icon: "icon-briefcase", sections: [1, 2] },
    { slug: "address", title: "Domicilio", icon: "icon-map-pin", sections: [4, 5] },
    // { slug: "bank", title: "Banco", icon: "icon-credit-card", sections:[6] },
    { slug: "contact", title: "Contacto", icon: "icon-phone", sections: [3, 10, 17, 18, 139] },
    { slug: "knowledge", title: "Conocimiento", icon: "icon-bookmark", sections: [22, 9] },
];

const pmTabsDefs = [
    { slug: "general", title: "Datos Generales", icon: "icon-briefcase", sections: [1, 11, 2] },
    { slug: "address", title: "Domicilio", icon: "icon-map-pin", sections: [23, 24] },
    // { slug: "bank", title: "Banco", icon: "icon-credit-card", sections:[13] },
    { slug: "contact", title: "Contacto", icon: "icon-phone", sections: [12, 138, 10, 17, 18] },
    { slug: "knowledge", title: "Conocimiento", icon: "icon-bookmark", sections: [22, 9] },
];

const sectionsToContainers = [
    { id: 1, containers: [{ db: 'suppliers', path: 'base' }] },
    { id: 2, containers: [{ db: 'suppliers', path: 'base' }] },
    {
        id: 3, containers: [
            { db: 'personal_profiles', path: 'user.personal' },
            { db: 'suppliers', path: 'base' },
            { db: 'personal_credit_profiles', path: 'user.personal.credit_profile' },
            { db: 'phones', path: 'user.personal.phone', arrayDefs: { onNull: 'newPhone' } },
        ]
    },
    { id: 4, containers: [{ db: 'addresses', path: 'user.personal.business_address' }] },
    { id: 139, containers: [{ db: 'addresses', path: 'user.personal.address' }] },
    { id: 5, containers: [{ db: 'addresses', path: 'user.personal.fiscal_address' }] },
    { id: 6, containers: [{ db: 'bank_accounts', path: 'user.personal.bank_accounts', arrayDefs: { getFirst: true, onNull: 'newBankAccount' } }] },
    { id: 9, containers: [{ db: 'suppliers', path: 'base' }] },
    {
        id: 10, containers: [
            { db: 'supplier_contacts', path: 'contacts', arrayDefs: { eval: 'filterGeneralContact', onNull: 'newGeneralContact' } },
            { db: 'phones', path: 'contacts', arrayDefs: { eval: 'filterGeneralContactForNumber', onNull: 'newPhone' } },
        ]
    },
    {
        id: 11, containers: [
            { db: 'business_profiles', path: 'user.business' },
            { db: 'business_profile_tins', path: 'user.business.tins', arrayDefs: {} },
            { db: 'phones', path: 'user.business.phone', arrayDefs: { onNull: 'newPhone' } },
            { db: 'business_credit_profiles', path: 'user.business.credit_profile' }
        ]
    },
    {
        id: 12, containers: [
            { db: 'personal_profiles', path: 'user.business.personal' },
            { db: 'phones', path: 'user.business.personal.phone', arrayDefs: { onNull: 'newPhone' } },
            { db: 'addresses', path: 'user.business.personal.address' },
            { db: 'business_profiles', path: 'user.business' },
            { db: 'business_profile_tins', path: 'user.business.tins', arrayDefs: {} },
            { db: 'personal_credit_profiles', path: 'user.business.personal.credit_profile' },
        ]
    },
    { id: 138, containers: [{ db: 'addresses', path: 'user.business.personal.address' }] },
    {
        id: 13, containers: [
            { db: 'bank_accounts', path: 'user.business.bank_accounts', arrayDefs: { getFirst: true, onNull: 'newBankAccount' } },
            { db: 'banks', path: 'bank_accounts_bank' }
        ]
    },
    {
        id: 17, containers: [
            { db: 'supplier_contacts', path: 'contacts', arrayDefs: { eval: 'filterCommercialContact', onNull: 'newCommercialContact' } },
            { db: 'phones', path: 'contacts', arrayDefs: { eval: 'filterCommercialContactForNumber', onNull: 'newPhone' } },
        ]
    },
    {
        id: 18, containers: [
            { db: 'supplier_contacts', path: 'contacts', arrayDefs: { eval: 'filterOperationsContact', onNull: 'newOperationsContact' } },
            { db: 'phones', path: 'contacts', arrayDefs: { eval: 'filterOperationsContactForNumber', onNull: 'newPhone' } },
        ]
    },
    { id: 22, containers: [] },
    { id: 23, containers: [{ db: 'addresses', path: 'user.business.address' }] },
    { id: 24, containers: [{ db: 'addresses', path: 'user.business.fiscal_address' }] }
];

const requiredObjects = [
    'user.personal.address',
    'user.personal.fiscalAddress',
    'user.personal.businessAddress',
    'user.personal.bankAccounts',
    'user.personal.tins',
    'user.personal.creditProfile',
    'user.personal.phone',
    'user.business.personal',
    'user.business.address',
    'user.business.tins',
    'user.business.phone',
    'user.business.personal.address',
    'user.business.personal.phone',
    'user.business.fiscalAddress',
    'user.business.bankAccounts.bank',
    'user.business.personal.creditProfile',
    'contacts',
    'tools',
    'customerTypes'
];

const arrayPaths = ['user.business.bank_accounts', 'user.personal.bank_accounts', 'user.business.tins', 'contacts', 'contacts.phone'];
const SUPPLIER_COMMERCIAL_COMMISSION_CONTRACT_TYPE = 5;
const SUPPLIER_CONSTANCY_KNWOLEDGE_TYPE = 14;

const addressMinDefault = {
    id: null,
    country_id: null,
    city_id: null,
};
const fiscalAddressMinDefault = {
    id: null,
    country_id: null,
    city_id: null,
    address_equals_fiscal_address: null
}
const verifiedEnumValue = "verificado";
const rejectedEnumValue = "rechazado";
const unverifiedEnumValue = "sin verificar";

const columns = [
    { title: "DOCUMENTO", key: "complete_name", sortable: true },
    { title: "ESTADO", key: "status", sortable: true },
    { title: "UBICACIÓN", key: "location", sortable: false },
    { title: "REQUERIDO", key: "location", sortable: false },
];

export default {
    mixins: [formHelper, inputHelper, dateHelper, docsHelper, userIdentityHelper],
    props: ['supplier_id', 'user_id', 'supplier_status', 'update_profile_info'],
    data() {
        return {
            documentsList: [],
            columns: columns,
            ekatena: [],

            moralTypeValue: 0,
            pfaeTypeValue: 1,
            flow_id_pfae: 1,
            flow_id_pm: 2,
            loading: false,
            isMounted: false,
            isRefreshing: false,
            errorMssg: '',
            successMssg: '',
            failed: false,
            flow: {},
            allSections: [],
            sectionGroups: [],
            documentsStates: [],

            tabs: [],

            supplierType: null,
            isMoral: false,
            isPfae: false,
            activeTab: 0,

            missing: {
                enterprise: '',
                acredit: '',
                contact: '',
                residence: '',
                bank: ''
            },

            collections: {
                cities: [],
                fiscal_cities: [],
                states: [],
                countries: [],
                foreign_countries: [],
                family_groups: [],
                tools: [],
                customer_types: [],
                banks: [],

                states_personal_address: [],
                cities_personal_address: [],
                neighborhoods_personal_address: [],
                states_personal_fiscal_address: [],
                cities_personal_fiscal_address: [],
                neighborhoods_personal_fiscal_address: [],
                states_business_address: [],
                cities_business_address: [],
                neighborhoods_business_address: [],
                states_business_fiscal_address: [],
                cities_business_fiscal_address: [],
                neighborhoods_business_fiscal_address: [],
                states_business_owner_personal_address: [],
                cities_business_owner_personal_address: [],
                neighborhoods_business_owner_personal_address: [],
                states_personal_business_owner_address: [],
                cities_personal_business_owner_address: [],
                neighborhoods_personal_business_owner_address: []
            },

            supplierTools: [],
            supplierCustomerTypes: [],
            supplierTins: [],

            // objeto principal
            base: {},

            // auxiliares para evaluacion de condiciones
            mexicoCountryId: 700,

            // objetos para actualizaciones
            basePayload: {},
            validatedFields: [],
            totalFields: 0,
            totalValidFields: 0,
            totalInvalidFields: 0,

            validatedDocuments: [],
            allDocumentFields: [],

            skipMissingWarnings: false,
            accreditationsMissing: null,
            merchantContractMissing: [],
            contractsMissing: 0,

            currentSupplierId: null,
            currentSupplierUserId: null,
            currentSupplierStatus: null,

            isBackoffice: false,

            bankAccountsValidation: null,
            status: null,
            identityIsCompleted: false,
            SUPPLIER_COMMERCIAL_COMMISSION_CONTRACT_TYPE: SUPPLIER_COMMERCIAL_COMMISSION_CONTRACT_TYPE,
            SUPPLIER_CONSTANCY_KNWOLEDGE_TYPE: SUPPLIER_CONSTANCY_KNWOLEDGE_TYPE,
            zipCode: null
        }
    },
    components: {
        FormField,
        SupplierCitiesControl,
        SupplierTestimoniesControl,
        PersonalProfileTinsControl,
        BusinessProfileTinsControl,
        AccreditationsControl,
        SupplierBankAccountsControl,
        SupplierIdentityVerification,
        ContractsPage,
        SupplierBranchesControl
    },
    computed: {
        supplier_data() {
            return [{
                type: 'supplier'
                , name: this.isMoral ? this.getPersonalFullName(this.businessOwner) : this.getPersonalFullName(this.personal)
                , email: this.base.user.email
                , telephone: this.isMoral ? this.businessOwner.phone : this.personal.phone
            }];
        },
        hasBackofficeAccess() {
            return this.$acl.check('isBackoffice');
        },
        isVerifiedOrProcess() {
            return this.currentSupplierStatus >= 3;
        },
        personal() {
            return this.base.user.personal;
        },
        business() {
            return this.base.user.business;
        },
        businessOwner() {
            return this.base.user.business.personal;
        },
        personalBankAccount() {
            return this.base.user.personal.bank_accounts[0];
        },
        businessBankAccount() {
            return this.base.user.business.bank_accounts[0];
        },
        supplier_pf_bank_account_exists() {
            return this.personalBankAccount && this.personalBankAccount.id != null;
        },
        supplier_pf_bank_account_id() {
            return this.personalBankAccount ? this.personalBankAccount.id : null;
        },
        supplier_pm_bank_account_exists() {
            return this.businessBankAccount && this.businessBankAccount.id != null;
        },
        supplier_pm_bank_account_id() {
            return this.businessBankAccount ? this.businessBankAccount.id : null
        },

        /* show_only_if getters */
        should_fill_personal_fiscal_address() {
            return !this.base.user.personal.fiscal_address.address_equals_fiscal_address;
        },
        should_fill_business_fiscal_address() {
            return !this.business.fiscal_address.address_equals_fiscal_address;
        },
        should_fill_business_mexican_address() {
            return this.business.address.country_id == this.mexicoCountryId;
        },
        should_fill_business_foreign_address() {
            return this.business.address.country_id != this.mexicoCountryId;
        },
        should_fill_business_mexican_fiscal_address() {
            return this.should_fill_business_fiscal_address
                && this.business.fiscal_address.country_id == this.mexicoCountryId;
        },
        should_fill_business_foreign_fiscal_address() {
            return this.should_fill_business_fiscal_address
                && this.business.fiscal_address.country_id != this.mexicoCountryId;
        },
        should_fill_pm_rfc() {
            return this.business.nationality == this.mexicoCountryId;
        },
        should_fill_business_tins() {
            return this.business.nationality && this.business.nationality != this.mexicoCountryId;
        },
        should_fill_personal_rfc() {
            // return this.personal.citizenship == this.mexicoCountryId;
            return this.supplierType == 1;
        },
        should_fill_owner_rfc_curp_fiscal_rec() {
            return this.businessOwner.citizenship == this.mexicoCountryId;
        },
        should_fill_owner_tins() {
            return this.businessOwner.citizenship && this.businessOwner.citizenship != this.mexicoCountryId;
        },
        should_fill_personal_curp() {
            return this.personal.citizenship == this.mexicoCountryId;
        },
        should_fill_owner_curp() {
            return this.businessOwner.citizenship == this.mexicoCountryId;
        },
        power_proof_is_required() {
            return this.business.power_proof_required;
        },
        should_fill_pm_foreign_bank_info() {
            return this.business.nationality != this.mexicoCountryId && !this.businessBankAccount.pm_bank_is_in_mexico;
        },
        should_fill_pm_clabe() {
            return (this.business.nationality == this.mexicoCountryId || this.businessBankAccount.pm_bank_is_in_mexico == true) && this.is_allowed;
        },
        should_fill_pm_swift_bic() {
            return this.should_fill_pm_foreign_bank_info && this.is_allowed;
        },
        should_fill_pm_account_number() {
            return (this.should_fill_pm_foreign_bank_info && (this.businessBankAccount.iban == null || this.businessBankAccount.iban == "") && this.is_allowed);
        },
        should_fill_pm_routing_number() {
            return (this.should_fill_pm_foreign_bank_info && (this.businessBankAccount.iban == null || this.businessBankAccount.iban == "") && this.is_allowed);
        },
        should_fill_pm_iban() {
            return this.should_fill_pm_foreign_bank_info && this.is_allowed;
        },
        should_fill_pm_bank_in_mexico() {
            return this.business.nationality != this.mexicoCountryId;
        },

        should_ask_for_pm_bank_confirmation() {
            return ((this.business.nationality != this.mexicoCountryId) && this.is_allowed);
        },

        /* disabled_if getters */
        should_fill_personal_bdate_gender() {
            return this.personal.citizenship == this.mexicoCountryId;
        },
        should_fill_owner_bdate_gender() {
            return this.businessOwner.citizenship == this.mexicoCountryId;
        },
        personal_clabe_from_bank() {
            return this.clabeBankName;
        },
        is_allowed() {
            return false;
        },
        updateRequired() {
            return this.currentSupplierStatus >= 4
                && this.update_profile_info.update_profile_requirement === 1
                && this.update_profile_info.update_profile_completed_for_review_date === null
        }
    },
    async beforeMount() {
        this.loading = true;
        this.isMounted = false;
        this.isBackoffice = process.env.VUE_APP_IS_BACKOFFICE == "true";
        this.setSupplier();
        await this.getCollections();
        await this.getSupplierData();
        await this.getSupplierStatusInfo();
        this.setPersonTypeInfo();
        await this.setCustomIntegrations();
        await this.getFormInfo();
        this.setSectionGroups();
        this.setBlockedDocuments();
        this.setTabFromParams();
        await this.runSilentValidation();
        this.isMounted = true;
        this.loading = false;
    },
    watch: {
        loading: function (newVal, oldVal) {
            if (newVal == true) {
                this.$vs.loading();
            }
            else {
                this.$vs.loading.close();
            }
        }
    },
    methods: {
        async reloadDocumentStatus() {
            this.showLoading(true);
            await this.getFormInfo();
            this.setSectionGroups();
            this.setBlockedDocuments();
            this.setTabFromParams();
            await this.runSilentValidation();
            this.showLoading(false);
        },
        zipcode_change_fill_address() {
            // console.log("on_change");
        },
        setSupplier() {
            if (this.isBackoffice) {
                this.currentSupplierId = this.$props.supplier_id;
                this.currentSupplierStatus = this.$props.supplier_status;
                this.currentSupplierUserId = this.$props.user_id;
            }
            else {
                this.currentSupplierId = this.SupplierId;
                this.currentSupplierStatus = this.SupplierStatus;
                this.currentSupplierUserId = this.UserId;
            }
        },
        setTabFromParams() {
            let techTab = this.tabs.length;

            let tab = this.$route.query.tab;
            if (tab && tab == "tecnologias") {
                this.activeTab = techTab;
            }
        },
        titleForTab(group) {
            if (group.failed == 0) {
                return group.title;
            }
            else {
                return `${group.title} ( ${group.failed} )`;
            }
        },
        resetCounters() {
            this.totalFields = 0;
            this.totalValidFields = 0;
            this.totalInvalidFields = 0;
            this.accreditationsMissing = null;
            this.merchantContractMissing = [];
            this.contractsMissing = 0;
        },
        async runSilentValidation() {
            this.resetCounters();
            let validator = new Validator();
            let container;
            this.documentsList = [];
            await this.asyncForEach(this.sectionGroups, async (group) => {
                group.missing = [];
                group.failed = 0;
                await this.asyncForEach(group.sections, async (section) => {
                    // console.log(section);
                    section.data.documentFields.forEach(df => {
                        if (this.needsToShowDocumentsSection(section)) {
                            if (!df.loadedState && df.documentSet.is_required == 1 && df.formField.bo_private != 1) {
                                if (df.formField.show_conditioned) {
                                    let inc = this.evaluateCondition(df.formField.condition);
                                    if (inc != true) {
                                        return;
                                    }
                                }
                                section.failed += 1;
                                group.failed += 1;
                                this.totalInvalidFields += 1;
                                group.missing.push({ n: df.documentSet.name, e: "Documento requerido" });
                                this.documentsList.push({ n: df.documentSet.name, e: "Documento requerido", section_id: df.formField.section_id, section_name: section.data.name, is_required: df.documentSet.is_required, color: 'gray' });
                            }
                            else if (df.loadedState && df.loadedState.is_verified == rejectedEnumValue) {
                                section.failed += 1;
                                group.failed += 1;
                                this.totalInvalidFields += 1;
                                group.missing.push({ n: df.documentSet.name, e: "Documento en estatus rechazado" });
                                this.documentsList.push({ n: df.documentSet.name, e: "Documento en estatus rechazado", section_id: df.formField.section_id, section_name: section.data.name, is_required: df.documentSet.is_required, color: 'danger' });
                            }
                            else if (df.loadedState && df.loadedState.is_verified == unverifiedEnumValue) {
                                section.failed += 1;
                                group.failed += 1;
                                this.totalInvalidFields += 1;
                                group.missing.push({ n: df.documentSet.name, e: "Documento en estatus sin verificar" });
                                this.documentsList.push({ n: df.documentSet.name, e: "Documento en estatus sin verificar", section_id: df.formField.section_id, section_name: section.data.name, is_required: df.documentSet.is_required, color: 'warning' });
                            } else if (df.loadedState && df.loadedState.is_verified == verifiedEnumValue) {
                                this.documentsList.push({ n: df.documentSet.name, e: "Documento verificado", section_id: df.formField.section_id, section_name: section.data.name, is_required: df.documentSet.is_required, color: 'success' });
                            }
                        }
                    });
                });
            });
        },
        async reloadFormInfo() {
            this.isRefreshing = true;
            await this.getSupplierData();
            await this.setCustomIntegrations();
            this.reloadSectionGroups();
            await this.runAddresses();
            this.isRefreshing = false;
        },
        async saveTabChanges(gslug) {
            this.loading = true;
            this.skipMissingWarnings = false;
            let result = await this.runValidations(gslug);
            if (!result) {
                if (!this.skipMissingWarnings) {
                    this.missingFieldsNotif();
                }
            }
            else {

                //guardar solo la informacion que se ha modificado
                this.basePayload = this.collectFormData(gslug);
                if (this.objectIsEmpty(this.basePayload) && gslug != "knowledge") {
                    //this.notFieldsToUpdate();
                    this.saveSuccessNotif();
                    this.loading = false;
                    return;
                }

                this.basePayload.id = this.base.id;
                if (gslug == 'knowledge') {
                    // recoleccion manual de valores
                    this.collectKnowledgeData();
                }

                try {
                    // ejecutar guardado
                    await axios.put(`/api/v1/supplier/${this.currentSupplierId}/deepUpdate`, this.basePayload);
                    // solicitar la informacion actualizada del modelo
                    await this.reloadFormInfo();

                    // actualizar la informacion general del usuario en caso de ser necesario
                    if (gslug == "general" && !this.isBackoffice) {
                        await this.onUserInfoUpdated();
                    }

                    this.saveSuccessNotif();
                }
                catch (error) {
                    this.warn(error);
                    this.failedOperationNotif(null, null);
                }
            }
            this.loading = false;
        },
        async runValidations(gslug) {
            // validar componentes tipo FormField
            let res1 = await this.validateFormFields(gslug);
            if (!res1) {
                return false;
            }

            // validar inputs instanciados en la vista
            let res2 = await this.$validator.validateAll();
            if (!res2) {
                return false;
            }

            // inspeccionar los campos para ejecutar validaciones especiales en campos tipo FormField
            //   let spValidation = await this.checkFormFieldsSpecialValidations(gslug);
            //   if(!spValidation){
            //    return false;
            //  }

            // inspeccionar los campos agregados directo en el componente para ejecutar validaciones especiales
            let group = this.sectionGroups.find(g => g.slug == gslug);
            let sp_failed = false;

            await this.asyncForEach(group.sections, async (s) => {
                await this.asyncForEach(s.data.fields.filter(f => f.special_definition == 1), async (f) => {
                    // considerar los campos habilitados (visibles), con validaciones especiales
                    if (this.fields[f.fname] && f.special_validation != null && f.special_validation.method != null) {
                        let res = await this[f.special_validation.method]();

                        if (!res) {
                            this.errors.add({
                                field: f.fname,
                                msg: f.special_validation.error
                            });
                            this.missingFieldsNotif(f.field_name, f.special_validation.error, 10000);
                            sp_failed = true;
                        }
                    }
                });
            });

            if (sp_failed) {
                this.skipMissingWarnings = true;
                return false;
            }

            let extra_valid = await this.extraValidations(gslug);
            if (!extra_valid) {
                this.skipMissingWarnings = true;
                return false;
            }

            // retornar true si todas las validaciones fueron positivas
            return true;
        },
        async extraValidations(group_slug) {
            let ok = true;
            if (group_slug == "contact") {
                // validar que los 3 juegos de datos de contacto sean distintos
                let general = this.base.contacts.find(f => f.type == 1);
                let comm = this.base.contacts.find(f => f.type == 2);
                let ops = this.base.contacts.find(f => f.type == 3);

                let n1 = general.name.toLowerCase();
                let n2 = ops.name.toLowerCase();
                let n3 = comm.name.toLowerCase();

                let e1 = general.email.toLowerCase();
                let e2 = ops.email.toLowerCase();
                let e3 = comm.email.toLowerCase();

                let p1 = general.phone;
                let p2 = comm.phone;
                let p3 = ops.phone;

                if (n1 == n2 || n1 == n3 || n3 == n2) {
                    ok = false;
                }
                if (e1 == e3 || e1 == e2 || e3 == e2) {
                    ok = false;
                }
                if (p1 == p2 || p1 == p3 || p2 == p3) {
                    ok = false;
                }

                if (!ok) {
                    this.errorNotif("Error en datos de contacto",
                        "Es necesario que los datos de contacto del Director General, Director Comercial y Director de Operaciones sean distintos entre sí.", 10000);
                }
            }
            return ok;
        },
        collectFormData(gslug) {
            let payload = {};
            let group = this.sectionGroups.find(g => g.slug == gslug);
            group.sections.forEach(section => {
                section.containers.forEach(cc => {
                    let fields = this.validatedFields.filter(vf => vf.db == cc.db);
                    if (fields.length < 1) {
                        return;
                    }

                    if (cc.path == "base") {
                        fields.forEach(f => {
                            payload[f.fname] = cc.container[f.fname];
                        });
                    }
                    else {
                        let obj = null;
                        if (arrayPaths.includes(cc.path)) {
                            // se integran todos los objetos de la coleccion
                            obj = this.nestedFieldValue(this.base, cc.path);
                        }
                        else {
                            obj = { id: cc.container.id };
                            fields.forEach(f => {
                                obj[f.fname] = cc.container[f.fname];
                            });
                        }
                        // ajuste para objetos tipo array
                        this.setDeepObjectWithIds(payload, this.base, cc.path, obj);
                    }
                });
            });
            return payload;
        },
        async validateFormFields(refGroup) {
            let allValid = true;
            this.validatedFields = [];
            let grefs = this.$refs[refGroup];
            let f;
            for (let p in grefs) {
                f = grefs[p];
                let r = await f.checkForValidDirty();
                if (r.valid == false) {
                    allValid = false;
                }
                else if (r.dirty == true) {
                    let sp = f.specialValidation();
                    if (sp != null && sp.method in this) {
                        let res = await this[sp.method]();
                        let n = f.rawFieldName;
                        if (!res) {
                            if (f.db_name === "rfc" && res.length === 0) {
                                continue;
                            }
                            this.skipMissingWarnings = true;
                            allValid = false;
                            f.setError(sp.error);
                            this.errorNotif(n, sp.error, 10000);
                            continue;
                        }
                    }
                    this.validatedFields.push(r);
                }
            }
            return allValid;
        },

        collectKnowledgeData() {
            // Herramientas del proveedor
            let t = [];
            this.supplierTools.forEach(f => {
                let item = {};
                item.type = f.type;
                item.other_tools = f.other_tools;
                item.checked = f.checked;
                t.push(item);
            });
            this.basePayload.tools = t;

            // Customer Types
            let c = [];
            this.supplierCustomerTypes.forEach(f => {
                let item = {};
                item.type = f.type;
                item.checked = f.checked;
                c.push(item);
            });
            this.basePayload.customer_types = c;
        },

        async requestVerification() {
            let ok = await this.checkForValidVerification();
            if (!ok) {
                return;
            }

            this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: 'Solicitar verificación de perfil',
                text: `¿Estás seguro que deseas enviar tu perfil a revisión? Una vez enviada no podrás modificar los datos.`,
                acceptText: "Enviar solicitud",
                cancelText: 'Cancelar',
                accept: this.doRequestVerification
            });
        },
        async doRequestVerification() {
            this.loading = true;
            try {
                let payload = { supplier_id: this.currentSupplierId };
                let res = await axios.post(`/api/v1/supplier/requestProfileVerification`, payload);
                if (res.data == "success") {
                    this.saveSuccessNotif("Perfil enviado a revisión", "Tu perfil ha sido enviado a revisión exitosamente. En breve tendrás respuesta.", 8000);
                    await this.onUserInfoUpdated();
                }
            } catch (error) {
                this.warn(error);
                this.failedOperationNotif(null, null);
            }
            this.loading = false;
        },
        async checkForValidVerification() {
            this.showLoading(true)
            // TODO verificar datos desde back
            await this.runSilentValidation();
            this.showLoading(false)
            if (this.totalInvalidFields > 0) {
                this.errorNotif("Campos pendientes",
                    "Existen campos pendientes para realizar la verificación. Por favor revisa las pestañas que indiquen un número de pendientes para ver el detalle.", 10000);
                return false;
            }
            return true;
        },

        /* on change receptor */
        onFieldChange(method) {
            if (method != null && method in this) {
                this[method]();
            }
        },

        /* evaluator */
        evaluateCondition(condition) {
            return this.evaluateConditionBase(this, condition);
        },

        /* obtener ids para los casos correspondientes */
        docTargetEvaluator(cls, cls_2) {
            if (cls == 'user' && cls_2 == 'supplier') {
                return this.currentSupplierUserId;
            }
            this.warn(`DOC TARGET NOT DEFINED FOR classifications: ${cls},${cls_2}`);
            return null;
        },

        setPersonTypeInfo() {
            this.supplierType = this.base.user.person_type;
            this.isMoral = this.supplierType == this.moralTypeValue;
            this.isPfae = this.supplierType == this.pfaeTypeValue;
            this.tabs = this.isMoral ? pmTabsDefs : pfaeTabsDefs;
        },
        async setCustomIntegrations() {
            // Herramientas del proveedor
            let t = [];
            this.collections.tools.forEach(f => {
                let ss = this.base.tools.find(x => x.type == f.type);
                let item = {};
                item.name = f.name;
                item.type = f.type;
                item.checked = ss != null;
                item.for_other = f.for_other;
                item.other_tools = ss != null ? ss.other_tools : null;
                t.push(item);
            });
            this.supplierTools = t;

            // Tipos de cliente del proveedor
            let c = [];
            this.collections.customer_types.forEach(f => {
                let item = {};
                item.type = f.type;
                item.name = f.name;
                item.checked = this.base.customer_types.find(x => x.type == f.type) != null;
                c.push(item);
            });
            this.supplierCustomerTypes = c;

            // direcciones personal profile
            let padd_sid = this.nestedFieldValue(this.base, 'user.personal.address.state_id');
            let pfadd_sid = this.nestedFieldValue(this.base, 'user.personal.fiscal_address.state_id');
            if (padd_sid != null && padd_sid != "") { await this.reload_personal_cities() }
            if (pfadd_sid != null && pfadd_sid != "") { await this.reload_personal_cities_fiscal() }

            let padd = this.nestedFieldValue(this.base, 'user.personal.address.id');
            let pfadd = this.nestedFieldValue(this.base, 'user.personal.fiscal_address.id');
            if (padd && pfadd && padd == pfadd) {
                this.personal.fiscal_address = fiscalAddressMinDefault;
                this.personal.fiscal_address.address_equals_fiscal_address = true;
            }

            // direcciones business profile
            let badd_sid = this.nestedFieldValue(this.base, 'user.business.address.state_id');
            let bfadd_sid = this.nestedFieldValue(this.base, 'user.business.fiscal_address.state_id');
            if (badd_sid != null && badd_sid != "") { await this.reload_business_cities() }
            if (bfadd_sid != null && bfadd_sid != "") { await this.reload_business_cities_fiscal() }

            let badd = this.nestedFieldValue(this.base, 'user.business.address.id');
            let bfadd = this.nestedFieldValue(this.base, 'user.business.fiscal_address.id');
            if (badd && bfadd && badd == bfadd) {
                this.business.fiscal_address = fiscalAddressMinDefault;
                this.business.fiscal_address.address_equals_fiscal_address = true;
            }
        },
        setSectionGroups() {
            this.sectionGroups = [];
            this.tabs.forEach(t => {
                let group = { title: t.title, icon: t.icon, slug: t.slug, missing: [] }; //, vModel: this.getModelForGroup(t.slug) };
                let sections = [];

                t.sections.forEach(ss => {
                    let s = this.allSections.find(f => f.id == ss);
                    if (s != null) {
                        let sb = { data: s, containers: this.getContainersForSection(s.id), failed: 0 };
                        sections.push(sb);
                    }
                    else {
                        this.warn("Section " + ss + " not found");
                    }
                })
                group.sections = sections;
                group.failed = 0;
                this.sectionGroups.push(group);
            });
        },
        reloadSectionGroups() {
            this.sectionGroups.forEach(group => {
                group.sections.forEach(s => {
                    s.containers = this.getContainersForSection(s.data.id);
                })
            });
        },
        /*getModelForGroup(slug){
          return this[slug];
        },*/
        getContainerForField(section, f) {
            let c = section.containers.find(sc => sc.db == f.db_table);
            if (!c) {
                this.warn(`Container not found for db [${f.fname}]: ${f.db_table}`);
                return null;
            }
            else {
                return c.container;
            }
        },
        getContainersForSection(section_id) {
            let c = sectionsToContainers.find(f => f.id == section_id);
            if (!c) {
                this.warn("Missing containers definition for section " + section_id);
                return null;
            }
            else {
                let sectionContainers = [];
                c.containers.forEach(cc => {
                    let con = this.setContainerFromDef(cc);
                    sectionContainers.push({ db: cc.db, path: cc.path, container: con });
                })
                return sectionContainers;
            }
        },
        setContainerFromDef(c) {
            let container = this.nestedFieldValue(this.base, c.path);
            if (Array.isArray(container)) {
                let ac = null;
                if (c.arrayDefs) {
                    if (c.arrayDefs.getFirst == true) {
                        ac = container[0];
                    }
                    else if (c.arrayDefs.eval) {
                        // llamado en funciones de secciones
                        // console.log(c.arrayDefs.eval);
                        ac = this[c.arrayDefs.eval](container);
                    }
                }
                if (!ac) {
                    if (c.arrayDefs.onNull) { ac = this[c.arrayDefs.onNull](); }
                    else { ac = {} }
                    container.push(ac);
                }
                return ac;
            }
            else {
                if (c.path == 'bank_accounts_bank') {
                    let accs = this.nestedFieldValue(this.base, 'user.business.bank_accounts');
                    let nbankAcc = accs[0];
                    return nbankAcc.bank;
                }
                if (container == null && c.arrayDefs) {
                    let ac = null;
                    if (c.arrayDefs.eval) {
                        // llamado en funciones de secciones
                        ac = this[c.arrayDefs.eval]();
                        return ac;
                    }
                    if (!ac) {
                        if (c.arrayDefs.onNull) { ac = this[c.arrayDefs.onNull](); }
                        else { ac = {} }
                        container = ac;
                    }
                }
                return container;
            }
        },
        async getSupplierStatusInfo() {
            // TODO
        },
        async getSupplierData() {
            try {
                // ?filter[status]=3 // ejemplo de filtro
                let params = "with[]=" + requiredObjects.join("&with[]=");
                let response = await axios.get(`/api/v1/supplier/${this.currentSupplierId}?${params}`);
                this.base = response.data;
            }
            catch (e) {
                this.warn(e);
                this.failed = true;
            }
        },
        async getFormInfo() {
            try {
                let id = this.isMoral == true ? this.flow_id_pm : this.flow_id_pfae;
                let response = await axios.get("/api/v1/forms/getFlowSectionFields/" + id);
                let url = this.ApiDomain + `/storagev3/documents/flow/${id}`;
                let response2 = await axios.get(url);
                this.documentsStates = response2.data;

                this.flow = response.data.flow;
                this.allSections = response.data.sections;
                this.allDocumentFields = [];

                await this.asyncForEach(this.allSections, async (s) => {
                    if (this.tabs.filter(tt => tt.sections.includes(s.id)).length < 1) {
                        return;
                    }

                    s.documentFields = [];
                    await this.asyncForEach(s.fields, async (f) => {
                        this.formFieldSetter(f, this);

                        // check for documents
                        if (f.doc_id != null) {
                            let ff = { formField: f, documentSet: null, target_id: null };
                            let ss = this.documentsStates.find(sid => sid.id == s.id);
                            if (ss && ss.documents) {
                                let dset = ss.documents.find(d => d.id == f.doc_id);
                                if (dset) {
                                    ff.target_id = this.docTargetEvaluator(dset.clasification, dset.clasification_2);
                                    ff.documentSet = dset;
                                }
                            }
                            s.documentFields.push(ff);
                            this.allDocumentFields.push(ff);
                        }
                    });

                    //   let states = await this.getAllDocumentsStates(allDocumentFields, this.evaluateCondition);

                    // solicitar los estatus de cada documento
                    /*
                    let file = await this.getDocumentState(ff.target_id, f.doc_id, dset.clasification, 
                    this.evaluateCondition, f.extras);
                    ff.loadedState = file;
          
                    // agregar a la lista de documentos verificados
                    if(file && file.is_verified == verifiedEnumValue){
                      this.validatedDocuments.push(f.doc_id);
                    }*/


                });

                let res = await this.getAllDocumentsStates(this.allDocumentFields, this.evaluateCondition);
                if (res) {
                    this.allDocumentFields.forEach(f => {
                        if (f.loadedState && f.loadedState.is_verified == verifiedEnumValue) {
                            this.validatedDocuments.push(f.documentSet.id);
                        }
                    })
                }
            }
            catch (e) {
                this.warn(e);
                this.failed = true;
            }
        },
        onDocumentUploadSuccess(data) {
            let d = this.allDocumentFields.find(f => f.documentSet.id == data.document_id);
            d.loadedState = data;
        },
        onDocumentRejected(data) {
            let d = this.allDocumentFields.find(f => f.documentSet.id == data.document_id);
            d.loadedState = data;
        },
        onDocumentVerified(data) {
            let d = this.allDocumentFields.find(f => f.documentSet.id == data.document_id);
            d.loadedState = data;
            this.validatedDocuments.push(d.documentSet.id);
            this.allSections.forEach(section => {
                section.fields.filter(f => f.block_by_document_id == data.document_id).forEach(fd => fd.blockedByDocument = true);
            })
        },
        onDocumentVerificationRevoked(data) {
            let d = this.allDocumentFields.find(f => f.documentSet.id == data.document_id);
            d.loadedState = data;
            this.validatedDocuments = this.validatedDocuments.filter(f => f != d.documentSet.id);
            this.allSections.forEach(section => {
                section.fields.filter(f => f.block_by_document_id == data.document_id).forEach(fd => fd.blockedByDocument = false);
            })
        },
        async getCollections() {
            try {
                let collectionsObjects = ['countriesList', 'foreignCountriesList', 'statesList', 'familyGroups', 'availableSupplierTools',
                    'supplierCustomerTypesCatalog', 'banksForMexico'];
                let params = "with[]=" + collectionsObjects.join("&with[]=");
                let res = await axios.get(`/api/v1/forms/getFormCollections?${params}`);
                let colls = res.data;
                this.collections.countries = colls.countriesList;
                this.collections.foreign_countries = colls.foreignCountriesList;
                this.collections.states = colls.statesList;
                this.collections.family_groups = colls.familyGroups;
                this.collections.tools = colls.availableSupplierTools;
                this.collections.customer_types = colls.supplierCustomerTypesCatalog;
                this.collections.banks = colls.banksForMexico;

            } catch (e) {
                this.warn(e);
                this.failed = true;
            }
        },

        setBlockedDocuments() {
            this.validatedDocuments.forEach(doc => {
                this.allSections.forEach(section => {
                    section.fields.filter(f => f.block_by_document_id == doc).forEach(fd => fd.blockedByDocument = true);
                })
            })
        },

        /* on_change methods */
        async reload_personal_cities() {
            try {
                let sid = this.personal.address.state_id;
                let res = await axios.get(`/api/register/cities/${sid}`);
                this.collections.cities = res.data;
                if (this.isMounted && !this.isRefreshing) this.personal.address.city_id = null;
            } catch (e) {
                this.warn(e);
            }
        },
        async reload_personal_cities_fiscal() {
            try {
                let sid = this.personal.fiscal_address.state_id;
                let res = await axios.get(`/api/register/cities/${sid}`);
                this.collections.fiscal_cities = res.data;
                if (this.isMounted && !this.isRefreshing) this.personal.fiscal_address.city_id = null;
            } catch (e) {
                this.warn(e);
            }
        },
        async reload_business_cities() {
            try {
                let sid = this.business.address.state_id;
                let res = await axios.get(`/api/register/cities/${sid}`);
                this.collections.cities = res.data;
                if (this.isMounted && !this.isRefreshing) this.business.address.city_id = null;
            } catch (e) {
                this.warn(e);
            }
        },
        async reload_business_cities_fiscal() {
            try {
                let sid = this.business.fiscal_address.state_id;
                let res = await axios.get(`/api/register/cities/${sid}`);
                this.collections.fiscal_cities = res.data;
                if (this.isMounted && !this.isRefreshing) this.business.fiscal_address.city_id = null;
            } catch (e) {
                this.warn(e);
            }
        },
        personal_curp_conditions_changed() {
            let c = this.personal.curp;
            if (!c) { return; }
            if (c.length >= 10) {
                let yy = c.slice(4, 6);
                let mm = c.slice(6, 8);
                let dd = c.slice(8, 10);

                let date = this.getDateFromInputs(yy, mm, dd);
                if (date === false) {
                    this.personal.birth_date = null;
                }
                else {
                    this.personal.birth_date = date;
                }
            }
            else {
                this.personal.birth_date = null;
            }

            if (c.length >= 11) {
                let g = c.slice(10, 11);
                if (g == "H") {
                    this.personal.gender = 1;
                }
                else if (g == "M") {
                    this.personal.gender = 2;
                }
                else {
                    this.personal.gender = null;
                }
            }
            else {
                this.personal.gender = null;
            }
        },
        owner_curp_conditions_changed() {
            let c = this.businessOwner.curp;
            if (!c) { return; }
            if (c.length >= 10) {
                let yy = c.slice(4, 6);
                let mm = c.slice(6, 8);
                let dd = c.slice(8, 10);

                let date = this.getDateFromInputs(yy, mm, dd);
                if (date === false) {
                    this.businessOwner.birth_date = null;
                }
                else {
                    this.businessOwner.birth_date = date;
                }
            }
            else {
                this.businessOwner.birth_date = null;
            }

            if (c.length >= 11) {
                let g = c.slice(10, 11);
                if (g == "H") {
                    this.businessOwner.gender = 1;
                }
                else if (g == "M") {
                    this.businessOwner.gender = 2;
                }
                else {
                    this.businessOwner.gender = null;
                }
            }
            else {
                this.businessOwner.gender = null;
            }
        },

        /* funciones de secciones */
        filterGeneralContact(collection) {
            return collection.find(f => f.type == 1);
        },
        filterCommercialContact(collection) {
            return collection.find(f => f.type == 2);
        },
        filterOperationsContact(collection) {
            return collection.find(f => f.type == 3);
        },
        filterGeneralContactForNumber() {
            return this.base.contacts.find(f => f.type == 1);
        },
        /* funciones de secciones */
        filterCommercialContactForNumber() {
            return this.base.contacts.find(f => f.type == 2);
        },
        filterOperationsContactForNumber() {
            return this.base.contacts.find(f => f.type == 3);
        },
        newGeneralContact() {
            return { type: 1 };
        },
        newCommercialContact() {
            return { type: 2 };
        },
        newOperationsContact() {
            return { type: 3 };
        },
        newBankAccount() {
            return { id: null, bank: {} };
        },

        newGeneralContact() {
            return { type: 1, phone: this.newPhone };
        },
        newCommercialContact() {
            return { type: 2, phone: this.newPhone };
        },
        newOperationsContact() {
            return { type: 3, phone: this.newPhone };
        },
        newBankAccount() {
            return { id: null, bank: {} };
        },
        newPhone() {
            return { country_calling_code: null, phone: null };
        },

        /* validaciones especiales */
        validate_user_birthdate() {
            let years = this.calculateAgeFromDate(this.personal.birth_date);
            return years >= 18;
        },

        validate_owner_birthdate() {
            let years = this.calculateAgeFromDate(this.businessOwner.birth_date);
            return years >= 18;
        },
        validate_supplier_tools() {
            return this.supplierTools.filter(f => f.checked == true).length > 0;
        },
        validate_supplier_customers() {
            return this.supplierCustomerTypes.filter(f => f.checked == true).length > 0;
        },
        async validate_supplier_cities() {
            try {
                let res = await axios.get(`/api/v1/supplier/${this.currentSupplierId}/getSupplierCities`);
                let cities = res.data.cities;
                let states = res.data.states;
                return cities.length > 0 || states.length > 0;
            } catch (error) {
                return false;
            }
        },
        validate_supplier_testimonies() {
            return this.$refs.supplier_testimonies_component[0].validate();
        },
        validate_personal_profile_tins() {
            if (this.$refs.personal_profile_tins_component[0] != null) {
                return this.$refs.personal_profile_tins_component[0].validate();
            }
            else {
                return true;
            }
        },
        validate_business_profile_tins() {
            if (this.$refs.business_profile_tins_component != null) {
                return this.$refs.business_profile_tins_component.validate();
            }
            else {
                return true;
            }
        },
        async validate_personal_unique_curp() {
            return await this.validate_unique_curp(this.personal.curp, this.personal.id)
        },
        async validate_owner_unique_curp() {
            return await this.validate_unique_curp(this.businessOwner.curp, this.businessOwner.id)
        },
        async validate_personal_clabe_is_valid() {
            return this.validate_clabe(this.personalBankAccount.clabe, this.collections.banks);
        },
        async validate_business_clabe_is_valid() {
            return this.validate_clabe(this.businessBankAccount.clabe, this.collections.banks);
        },
        async validate_owner_clabe_is_valid() {
            return this.validate_clabe(this.businessOwner.bank_accounts[0].clabe, this.collections.banks);
        },
        async validate_personal_unique_rfc() {
            return await this.validate_unique_personal_rfc(this.personal.rfc, this.personal.id)
        },
        async validate_pm_unique_rfc() {
            return await this.validate_unique_business_rfc(this.business.rfc, this.business.id)
        },
        async validate_owner_unique_rfc() {
            return await this.validate_unique_personal_rfc(this.businessOwner.rfc, this.businessOwner.id)
        },
        needsToShowDocumentsSection(section) {
            if (this.isMoral) {
                return section.data.id === 13 ? false : true;
            } else {
                return section.data.id === 6 ? false : true;
            }
        },
        needsToShowSaveButton(slug) {
            return slug === "bank" ? false : true;
        },
        async validate_bank_accounts_special() {
            try {
                let action_needed = this.isBackoffice ? 2 : 1;
                let id = this.currentSupplierUserId;
                const res = await axios.get(`/api/v1/supplier/userBankAccounts/${action_needed}/${id}/verify`)
                this.bankAccountsValidation = res.data;
                let allComplete = true;

                if (res.data.totalAccounts < 1) {
                    return false;
                }

                if (!this.bankAccountsValidation.accountsComplete) {
                    allComplete = false;
                }

                return allComplete;
            } catch (e) {
                this.warn(e);
            }
            return false;
        },
        async validate_bank_accounts_special_error() {
            if (!this.bankAccountsValidation) {
                return "Información pendiente";
            }

            if (this.bankAccountsValidation.totalAccounts < 1) {
                return "Debe agregar al menos 1 cuenta bancaria para realizar movimientos dentro de la plataforma."
            } else {
                if (!this.bankAccountsValidation.accountsComplete) {
                    return "Debe completar la información de por lo menos una cuenta bancaria. (Cuenta CLABE y carátula)"
                }
            }
        },
        async validate_identity_verification() {
            this.status = await this.getUserIdentityStatus(this.currentSupplierUserId);
            this.identityIsCompleted = this.verificationIsCompleted(this.status);

            return this.identityIsCompleted;
        },
        async validate_identity_verification_error() {
            if (!this.identityIsCompleted) {
                return "La verificación de identidad con Mati no ha sido completada.";
            }
        },
        getPersonalFullName(personal) {
            let name = personal.first_name;
            if (personal.second_name !== null) {
                name += ` ${personal.second_name}`;
            }
            name += ` ${personal.last_name_1}`
            if (personal.last_name_2 !== null) {
                name += ` ${personal.last_name_2}`
            }

            return name;
        },
        runAddresses() {
            if (this.isMoral) {
                this.set_zip_code_values_business_fiscal_address();
                this.set_zip_code_values_business_address();
                this.set_zip_code_business_owner_personal_address();
            } else {
                this.set_zip_code_personal_business_owner_address();
                this.set_zip_code_values_personal_address();
                this.set_zip_code_values_personal_fiscal_address();
            }
        },
        verify_zip_code_business_fiscal_address() {
            this.verifyZipCode(this.business.fiscal_address, {
                zipCodeVariable: 'zip_code_business_fiscal_address',
                statesArray: 'states_business_fiscal_address',
                citiesArray: 'cities_business_fiscal_address',
                neighborhoodsArray: 'neighborhoods_business_fiscal_address'
            });
        },
        set_zip_code_values_business_fiscal_address() {
            this.setZipCodeAddressValues(this.business.fiscal_address_id, this.business.fiscal_address, {
                zipCodeVariable: 'zip_code_business_fiscal_address',
                statesArray: 'states_business_fiscal_address',
                citiesArray: 'cities_business_fiscal_address',
                neighborhoodsArray: 'neighborhoods_business_fiscal_address'
            });
        },

        verify_zip_code_business_address() {
            this.verifyZipCode(this.business.address, {
                zipCodeVariable: 'zip_code_business_address',
                statesArray: 'states_business_address',
                citiesArray: 'cities_business_address',
                neighborhoodsArray: 'neighborhoods_business_address'
            });
        },
        set_zip_code_values_business_address() {
            this.zip_code_business_fiscal_address = '';
            this.setZipCodeAddressValues(this.business.address_id, this.business.address, {
                zipCodeVariable: 'zip_code_business_address',
                statesArray: 'states_business_address',
                citiesArray: 'cities_business_address',
                neighborhoodsArray: 'neighborhoods_business_address'
            });
        },

        verify_zip_code_personal_address() {
            this.verifyZipCode(this.personal.business_address, {
                zipCodeVariable: 'zip_code_personal_address',
                statesArray: 'states_personal_address',
                citiesArray: 'cities_personal_address',
                neighborhoodsArray: 'neighborhoods_personal_address'
            });
        },
        set_zip_code_values_personal_address() {
            this.zip_code_personal_fiscal_address = '';
            this.setZipCodeAddressValues(this.personal.business_address_id, this.personal.business_address, {
                zipCodeVariable: 'zip_code_personal_address',
                statesArray: 'states_personal_address',
                citiesArray: 'cities_personal_address',
                neighborhoodsArray: 'neighborhoods_personal_address'
            });
        },

        verify_zip_code_personal_fiscal_address() {
            this.verifyZipCode(this.personal.fiscal_address, {
                zipCodeVariable: 'zip_code_personal_fiscal_address',
                statesArray: 'states_personal_fiscal_address',
                citiesArray: 'cities_personal_fiscal_address',
                neighborhoodsArray: 'neighborhoods_personal_fiscal_address'
            });
        },
        set_zip_code_values_personal_fiscal_address() {
            this.setZipCodeAddressValues(this.personal.fiscal_address_id, this.personal.fiscal_address, {
                zipCodeVariable: 'zip_code_personal_fiscal_address',
                statesArray: 'states_personal_fiscal_address',
                citiesArray: 'cities_personal_fiscal_address',
                neighborhoodsArray: 'neighborhoods_personal_fiscal_address'
            });
        },

        verify_zip_code_business_owner_personal_address() {
            this.verifyZipCode(this.business.personal.address, {
                zipCodeVariable: 'zip_code_business_owner_personal_address',
                statesArray: 'states_business_owner_personal_address',
                citiesArray: 'cities_business_owner_personal_address',
                neighborhoodsArray: 'neighborhoods_business_owner_personal_address'
            });
        },
        set_zip_code_business_owner_personal_address() {
            this.setZipCodeAddressValues(this.business.personal.address_id, this.business.personal.address, {
                zipCodeVariable: 'zip_code_business_owner_personal_address',
                statesArray: 'states_business_owner_personal_address',
                citiesArray: 'cities_business_owner_personal_address',
                neighborhoodsArray: 'neighborhoods_business_owner_personal_address'
            });
        },

        verify_zip_code_personal_business_owner_address() {
            this.verifyZipCode(this.personal.address, {
                zipCodeVariable: 'zip_code_personal_business_owner_address',
                statesArray: 'states_personal_business_owner_address',
                citiesArray: 'cities_personal_business_owner_address',
                neighborhoodsArray: 'neighborhoods_personal_business_owner_address'
            });
        },
        set_zip_code_personal_business_owner_address() {
            this.setZipCodeAddressValues(this.personal.address_id, this.personal.address, {
                zipCodeVariable: 'zip_code_personal_business_owner_address',
                statesArray: 'states_personal_business_owner_address',
                citiesArray: 'cities_personal_business_owner_address',
                neighborhoodsArray: 'neighborhoods_personal_business_owner_address'
            });
        }
    }
}
</script>
<style>.vuesax-app-is-ltr .vs-tabs--btn-icon+span {
    font-weight: 600 !important;
}

.rg-title {
    font-size: 3rem !important;
}

.con-vs-dialog .vs-dialog {
    z-index: 90000 !important;
}

div#pop-up-bankaccounts {
    z-index: 15000 !important;
}</style>